import "core-js/modules/es6.regexp.replace";
export default (function (phone) {
  return typeof phone === 'string' && phone.replace(/\D+/g, '').length === 10;
});